import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../utils/constants';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Track Facebook Pixel Purchase Event
    if (typeof window.fbq !== 'undefined') {
      // Get purchase details from URL params
      const amount = searchParams.get('amount') || '0';
      const purchaseType = searchParams.get('type') || 'individual';
      const itemId = searchParams.get('item_id') || '';
      const itemCount = searchParams.get('count') || '1';
      
      // Parse amount to number (in DZD)
      const amountDZD = parseFloat(amount);
      
      // Only track if we have a valid amount
      if (amountDZD > 0) {
        // Convert DZD to USD for Facebook (real market rate: 1 USD = 250 DZD)
        // Facebook Pixel doesn't fully support DZD, so we use USD
        const amountUSD = (amountDZD / 250).toFixed(2);
        
        console.log('🎯 Facebook Pixel: Tracking Purchase', { 
          amountDZD: amountDZD,
          amountUSD: amountUSD,
          purchaseType, 
          itemId 
        });
        
        // Prepare content_ids array
        let contentIds = [];
        if (itemId) {
          // For bundles, itemId is comma-separated
          contentIds = itemId.includes(',') ? itemId.split(',') : [itemId];
        }
        
        // Determine content name
        let contentName = 'Course Purchase';
        if (purchaseType === 'subscription') {
          contentName = 'Monthly Subscription';
        } else if (purchaseType === 'bundle') {
          contentName = `Smart Bundle (${itemCount} items)`;
        }
        
        // Convert to USD for Facebook Pixel (DZD not fully supported by Pixel API)
        // Note: Your system still uses DZD - this is only for Facebook tracking
        window.fbq('track', 'Purchase', {
          value: parseFloat(amountUSD),
          currency: 'USD',
          content_type: purchaseType === 'bundle' ? 'bundle' : 'product',
          content_ids: contentIds,
          content_name: contentName,
          num_items: parseInt(itemCount) || 1
        });
        
        console.log('✅ Facebook Pixel: Purchase tracked successfully');
      } else {
        console.warn('⚠️ Facebook Pixel: Skipping Purchase event - no amount provided');
      }
    }

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(ROUTES.DASHBOARD);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center p-6" dir="rtl">
      <div className="max-w-2xl w-full">
        <div className="bg-white rounded-3xl shadow-custom-lg p-8 md:p-12 text-center animate-slideUp">
          {/* Success Icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center text-white text-5xl mx-auto mb-8 animate-bounce">
            <i className="fas fa-check"></i>
          </div>

          {/* Success Message */}
          <h1 className="text-4xl font-black text-text mb-4">
            تم الدفع بنجاح!
          </h1>
          
          <p className="text-xl text-text2 mb-8">
            تهانينا! تم تأكيد عملية الشراء بنجاح
          </p>

          {/* Details */}
          <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl p-6 mb-8">
            <div className="space-y-3 text-right">
              <div className="flex items-center justify-between">
                <span className="text-text2">✓ تم إضافة الدورة لحسابك</span>
                <i className="fas fa-book-open text-primary text-xl"></i>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-text2">✓ يمكنك الآن بدء الدراسة مباشرة</span>
                <i className="fas fa-play-circle text-secondary text-xl"></i>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-text2">✓ تم إرسال رسالة تأكيد لبريدك</span>
                <i className="fas fa-envelope text-primary text-xl"></i>
              </div>
            </div>
          </div>

          {/* Countdown */}
          <p className="text-text3 mb-6">
            سيتم تحويلك للوحة التحكم خلال {countdown} ثواني...
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(ROUTES.DASHBOARD)}
              className="btn-primary text-lg px-8 py-4"
            >
              <i className="fas fa-home ml-2"></i>
              الذهاب للوحة التحكم
            </button>
          </div>

          {/* Footer Note */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-text3">
              <i className="fas fa-info-circle ml-1"></i>
              إذا واجهت أي مشكلة، يمكنك التواصل مع الدعم الفني
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
